module.exports = __webpack_public_path__ + "static/media/JM_iconos-08_codigo.a7a4dfff.svg";